export const onAdd = (section, index, block) => ({
  type: 'ADD',
  section,
  index,
  block
})

export const onClone = (section, index) => ({
  type: 'CLONE',
  section,
  index
})

export const onEdit = (section, index) => ({
  type: 'EDIT',
  section,
  index
})

export const onMove = (from, to) => ({
  type: 'MOVE',
  from,
  to
})

export const onRemove = (section, index) => ({
  type: 'REMOVE',
  section,
  index
})

export const onSetConfig = (config) => ({
  type: 'SET_CONFIG',
  config
})

export const onSetStatus = (status) => ({
  type: 'SET_STATUS',
  status
})

export const onUpdate = (key, value) => ({
  type: 'UPDATE',
  key,
  value
})
